import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactSidebar = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    setCurrentLanguage(savedLanguage);
  }, []);

  const teamMembers = [
    {
      name: 'Peter Mugambi Muthuri',
      title: currentLanguage === 'en' ? 'Senior Partner' : 'Mshirika Mkuu',
      specialization: currentLanguage === 'en' ? 'Corporate & Commercial Law' : 'Sheria ya Makampuni na Kibiashara',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
      phone: '+254 721 320 787',
      email: 'peter@peterpartnerslaw.co.ke'
    },
    {
      name: 'Judy Nyakio Muriithi',
      title: currentLanguage === 'en' ? 'Partner' : 'Mshirika',
      specialization: currentLanguage === 'en' ? 'Family & Property Law' : 'Sheria ya Familia na Mali',
      image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face',
      phone: '+254 721 320 787',
      email: 'judy@peterpartnerslaw.co.ke'
    }
  ];

  const contactInfo = {
    office: {
      address: currentLanguage === 'en' ?'Nairobi CBD, Kenya' :'Nairobi CBD, Kenya',
      phone: '+254 721 320 787',
      email: 'info@peterpartnerslaw.co.ke',
      hours: currentLanguage === 'en' ?'Mon - Fri: 8:00 AM - 6:00 PM' :'Jumatatu - Ijumaa: 8:00 AM - 6:00 PM'
    }
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(currentLanguage === 'en' ?'Hello, I would like to schedule a consultation for legal services.' :'Hujambo, ningependa kupanga mazungumzo kwa huduma za kisheria.');
    window.open(`https://wa.me/254721320787?text=${message}`, '_blank');
  };

  const handleCallClick = () => {
    window.open('tel:+254721320787', '_self');
  };

  const handleEmailClick = () => {
    window.open('mailto:info@peterpartnerslaw.co.ke', '_blank');
  };

  return (
    <div className="space-y-8">
      {/* Quick Contact */}
      <div className="bg-white rounded-2xl p-6 shadow-md border border-border-light">
        <h3 className="text-xl font-heading font-semibold text-text-primary mb-6">
          {currentLanguage === 'en' ? 'Get Legal Help Now' : 'Pata Msaada wa Kisheria Sasa'}
        </h3>
        
        <div className="space-y-4">
          <Button
            variant="primary"
            onClick={handleWhatsAppClick}
            iconName="MessageCircle"
            iconPosition="left"
            fullWidth
            size="lg"
          >
            {currentLanguage === 'en' ? 'WhatsApp Consultation' : 'Mazungumzo ya WhatsApp'}
          </Button>
          
          <Button
            variant="outline"
            onClick={handleCallClick}
            iconName="Phone"
            iconPosition="left"
            fullWidth
            size="lg"
          >
            {currentLanguage === 'en' ? 'Call Now' : 'Piga Simu Sasa'}
          </Button>
          
          <Button
            variant="ghost"
            onClick={handleEmailClick}
            iconName="Mail"
            iconPosition="left"
            fullWidth
            size="lg"
          >
            {currentLanguage === 'en' ? 'Send Email' : 'Tuma Barua Pepe'}
          </Button>
        </div>
      </div>

      {/* Office Information */}
      <div className="bg-gradient-to-br from-surface/10 to-primary/10 rounded-2xl p-6 border border-primary/20">
        <h3 className="text-xl font-heading font-semibold text-text-primary mb-6">
          {currentLanguage === 'en' ? 'Office Information' : 'Taarifa za Ofisi'}
        </h3>
        
        <div className="space-y-4">
          <div className="flex items-start space-x-3">
            <Icon name="MapPin" size={20} className="text-primary mt-1 flex-shrink-0" />
            <div>
              <p className="font-medium text-text-primary">
                {currentLanguage === 'en' ? 'Address' : 'Anwani'}
              </p>
              <p className="text-text-secondary text-sm">
                {contactInfo.office.address}
              </p>
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <Icon name="Phone" size={20} className="text-primary mt-1 flex-shrink-0" />
            <div>
              <p className="font-medium text-text-primary">
                {currentLanguage === 'en' ? 'Phone' : 'Simu'}
              </p>
              <p className="text-text-secondary text-sm">
                {contactInfo.office.phone}
              </p>
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <Icon name="Mail" size={20} className="text-primary mt-1 flex-shrink-0" />
            <div>
              <p className="font-medium text-text-primary">
                {currentLanguage === 'en' ? 'Email' : 'Barua Pepe'}
              </p>
              <p className="text-text-secondary text-sm">
                {contactInfo.office.email}
              </p>
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <Icon name="Clock" size={20} className="text-primary mt-1 flex-shrink-0" />
            <div>
              <p className="font-medium text-text-primary">
                {currentLanguage === 'en' ? 'Office Hours' : 'Masaa ya Ofisi'}
              </p>
              <p className="text-text-secondary text-sm">
                {contactInfo.office.hours}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Team Members */}
      <div className="bg-white rounded-2xl p-6 shadow-md border border-border-light">
        <h3 className="text-xl font-heading font-semibold text-text-primary mb-6">
          {currentLanguage === 'en' ? 'Our Legal Team' : 'Timu Yetu ya Kisheria'}
        </h3>
        
        <div className="space-y-6">
          {teamMembers.map((member, index) => (
            <div key={index} className="flex items-start space-x-4">
              <img
                src={member.image}
                alt={member.name}
                className="w-16 h-16 rounded-xl object-cover border-2 border-primary/20"
              />
              <div className="flex-1">
                <h4 className="font-heading font-semibold text-text-primary text-sm">
                  {member.name}
                </h4>
                <p className="text-primary text-xs font-medium mb-1">
                  {member.title}
                </p>
                <p className="text-text-secondary text-xs">
                  {member.specialization}
                </p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-6 pt-6 border-t border-border-light">
          <Link
            to="/team-profiles"
            className="inline-flex items-center text-primary hover:text-accent transition-colors duration-200 text-sm font-medium"
          >
            {currentLanguage === 'en' ? 'View Full Team' : 'Ona Timu Kamili'}
            <Icon name="ArrowRight" size={16} className="ml-2" />
          </Link>
        </div>
      </div>

      {/* Emergency Contact */}
      <div className="bg-gradient-to-br from-accent/10 to-primary/10 rounded-2xl p-6 border border-accent/20">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-accent rounded-xl mb-4">
            <Icon name="AlertCircle" size={24} color="white" strokeWidth={2} />
          </div>
          <h3 className="text-lg font-heading font-semibold text-text-primary mb-2">
            {currentLanguage === 'en' ? 'Emergency Legal Help' : 'Msaada wa Dharura wa Kisheria'}
          </h3>
          <p className="text-text-secondary text-sm mb-4">
            {currentLanguage === 'en' ?'Available 24/7 for urgent legal matters' :'Inapatikana saa 24/7 kwa mambo ya haraka ya kisheria'
            }
          </p>
          <Button
            variant="primary"
            onClick={handleCallClick}
            iconName="Phone"
            iconPosition="left"
            size="sm"
            fullWidth
          >
            {currentLanguage === 'en' ? 'Call Emergency Line' : 'Piga Simu ya Dharura'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContactSidebar;